import React from 'react';
import styled from 'styled-components';
import { _ } from '@splunk/ui-utils/i18n';
import { variables } from '@splunk/themes';
import { colorWithAlpha } from '@splunk/themes/mixins';
import Typography from '@splunk/react-ui/Typography';
import Message from '@splunk/react-ui/Message';

const ErrorOverlay = styled.div<{ zIndex?: number }>`
    position: absolute;
    overflow: auto;
    box-sizing: border-box;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
    background-color: ${colorWithAlpha(
        variables.notificationColorNegativeWeak,
        0.7
    )};
    padding: ${variables.spacingSmall};
    z-index: ${(props) => props.zIndex ?? 2};
`;

export const GridErrorMessage = ({
    messages,
    zIndex,
}: {
    messages?: string[];
    zIndex?: number;
}) => {
    if (!Array.isArray(messages) || messages.length === 0) {
        return null;
    }
    return (
        <ErrorOverlay data-test="grid-layout-error-overlay" zIndex={zIndex}>
            <Message appearance="fill" type="error">
                <Message.Title>
                    {_('Viz panel incorrectly configured.')}
                </Message.Title>
                {messages.map((message) => (
                    <Typography
                        as="p"
                        data-test="grid-layout-error-message"
                        key={message}
                    >
                        {message}
                    </Typography>
                ))}
            </Message>
        </ErrorOverlay>
    );
};
